/* @flow */

import jQuery from 'jquery';

type Placement = 'top' | 'bottom' | 'left' | 'right' | 'auto';

export type ConteudoPopover = {
    titulo?: string,
    texto?: string,
    sim?: string,
    nao?: string,
    posicao?: Placement,
    timeout?: number,
};

const defaultOptions = {
    titulo: 'Confirmar ação?',
    sim: 'Sim',
    nao: 'Não',
    posicao: 'auto',
    timeout: 5000,
};

const template = valores => `<div class="m-popover popover fade popover-confirmacao" role="tooltip">
        <div class="arrow"></div>
        <h3 class="popover-header"></h3>
        ${valores.texto ? '<div class="popover-body"></div>' : ''}
        <div style="padding: 12px 15px;">
            <a class="btn btn-sm btn-default botao-nao">
                ${valores.nao}
            </a>
            <a class="btn btn-sm btn-success" tabindex="0" style="margin-left: 5px;">
                <i class="fa fa-check"></i>&nbsp;
                ${valores.sim}
            </a>
        </div>
    </div>`.replace(/>\s+</g, '><');


const popoverConfirmacao = (
    container: Element,
    opcoes: ConteudoPopover = {},
): Promise<void> => new Promise((resolve, reject) => {
    const valores = Object.assign({}, defaultOptions, opcoes);
    const $ = global.$ || jQuery;
    $('.popover').popover('hide');
    const $container: any = $(container);
    const parent = container.parentElement;
    if (!parent) {
        return;
    }
    const timeout = setTimeout(() => {
        $container.popover('hide');
        reject();
    }, valores.timeout);

    $container
        .popover({
            title: valores.titulo,
            content: valores.texto,
            html: true,
            placement: valores.posicao,
            template: template(valores),
            trigger: 'manual',
        })
        .popover('show');

    const success = document.querySelector('.popover-confirmacao .btn-success');
    const danger = document.querySelector('.popover-confirmacao .botao-nao');
    if (success) {
        success.onclick = () => {
            clearTimeout(timeout);
            $container.popover('hide');
            resolve();
        };
    }

    if (danger) {
        danger.onclick = () => {
            clearTimeout(timeout);
            $container.popover('hide');
            reject();
        };
    }
});

export default popoverConfirmacao;
